import Button from 'components/Button'
import DeleteImage from 'components/Images/OBJECTS.png'
import DuplicateImage from 'components/Images/duplicate.png'
import PublishImage from 'components/Images/publish.png'
import React from 'react'
import {
  ButtonDiv,
  ModalContent,
  ModalOverlay,
  ModalText,
  ShortListModalImg,
} from '../../../Preview/Partials/PreviewBox/style'
const Modal = ({ onClose, children }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>{children}</ModalContent>
    </ModalOverlay>
  )
}
export default function ActionModal({
  isModalVisible,
  handleCloseModal,
  modalContent,
  handleConfirmAction,
}) {
  return (
    <>
      {isModalVisible && (
        <Modal onClose={handleCloseModal}>
          <ShortListModalImg>
            {modalContent.image === 'deleteImage' ? (
              <img src={DeleteImage} alt="DeleteState" />
            ) : modalContent.image === 'publishImage' ? (
              <img src={PublishImage} alt="PublishState" />
            ) : modalContent.image === 'duplicateImage' ? (
              <img src={DuplicateImage} alt="DuplicateState" />
            ) : (
              <div>No Image Found</div>
            )}
          </ShortListModalImg>
          <ModalText>{modalContent.text}</ModalText>
          <ButtonDiv>
            <>
              <Button.Secondary
                height={'38px'}
                text={'No'}
                onClick={handleCloseModal}
              />
              <Button.Primary
                height={'38px'}
                text={'Yes'}
                onClick={handleConfirmAction}
              />
            </>
          </ButtonDiv>
        </Modal>
      )}
    </>
  )
}
